document.addEventListener('DOMContentLoaded', function () {
  const currency =
    window.ShopLocale?.currency ||
    window.Shopify?.currency?.active ||
    'USD';
  
  async function generateAndRedirect() {
    const country = window?.ShopLocale?.countryCode || window?.Shopify?.country;
    const language = window?.ShopLocale?.language || window?.Shopify?.locale;
    const ietfLocale = (language?language:"");

    const cartRes = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' }});
    const cart = await cartRes.json();

    const payload = {
      currency,
      items: cart.items,
      token: cart.token,
      isUserLoggedIn: window.ShapeTech.isUserLoggedIn,
      noteAttributes: cart.attributes,
      countryCode: window?.ShopLocale?.countryCode || window?.Shopify?.country,
      languageCode: window?.ShopLocale?.language || window?.Shopify?.locale,
      customerEmail: window.ShapeTech?.customerEmail ?? undefined
    };

    const res = await fetch(`${stAppConfig.apiRoot}/cart/sca/generate-cart`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const shopLocale = window?.ShopLocale?.language || window?.Shopify?.locale;
    console.log("[ShapeTech] Shop locale", shopLocale);

    const { data, message } = await res.json();
    if(data) {
      let redirectPath = data;
      console.log("[ShapeTech] Checkout redirect path", redirectPath);
      //if(language) {
      //  redirectPath = data.replace('/cart/', '/'+language+'/cart/');
      //}

      const [base, returnTo] = redirectPath.split("return_to=");
      if(!!returnTo) {
        const returnToComponents = returnTo.split("?");
        // TODO: Refactor this block and make sure returnTo is properly sanitised for URLs on server side, and then processed here correctly.
        // intentionally using "split" instead of "includes" to address links with "?" but no parameters
        let updatedReturnTo;
        if(returnToComponents.length > 1 && returnToComponents[1] !== "" ) {
          updatedReturnTo = returnToComponents[0] + "?" + returnToComponents[1] + "&locale="+shopLocale;
        } else {
          updatedReturnTo = returnToComponents[0] + "?locale="+shopLocale;
        }
        redirectPath = `${base}return_to=${encodeURIComponent(updatedReturnTo)}`;
      } else {
        // redirect path example
        // https://pruvit-prod-exp-apac.myshopify.com/cart/c/hWN8G0jtzFpY5Jx6HFfOV3Lu?key=264c6fb2fd1e553811fccc2547fa7428
        if (redirectPath.includes('?')) {
          redirectPath = redirectPath + '&locale=' + shopLocale;
        } else {
          redirectPath = redirectPath + '?locale=' + shopLocale;
        }
      }
      console.log("[ShapeTech] Final checkout redirect path", redirectPath);
      window.location.href = redirectPath;

    } else throw new Error(message ?? 'Missing redirect URL from generate-cart');
  }

  document.querySelector('body').addEventListener('click', async(e) => {
    let preventCheckout = false;
    let trigger = e.target;
      if(trigger && trigger.classList.contains('custom_checkout_button_JS')) {
        preventCheckout = true;
      } else {
        trigger = e.target.closest('button');
        if(trigger && trigger.classList.contains('custom_checkout_button_JS')) {
          preventCheckout = true;
        }
      }

    if(preventCheckout) {
      e.preventDefault();
      trigger.disabled = true;

      try {
        // Read current cart, create a new cart and redirect
        await generateAndRedirect();
      } catch (err) {
        console.error('Checkout error:', err);
        alert(err?.message);
      } finally {
        trigger.disabled = false;
      }
    }
  });
});